// extracted by mini-css-extract-plugin
module.exports = {"modalWrap":"_1keDq","header":"S_DON","close":"_2OnxA","outer":"_3IVU3","heading":"_2omO-","buttonWrap":"_1f9XG"};